import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	NgZone,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core';
import {
	faAngleLeft,
	faAngleRight,
	faGripVertical,
	faInfoCircle,
	faQuestionCircle,
	faSearch,
	faSquarePen,
	faTimes,
	faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { GenericFormGenService } from './service/generic-form-gen.service';
import { ShkDate } from 'shk-date';
import { FilesService } from 'src/app/services/files/files.service';
import { mimeTypeInterface } from 'src/app/util/interfaces/mimeTypeInterface';
import { forkJoin } from 'rxjs';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { ActivatedRoute } from '@angular/router';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'cpi-generic-form-gen',
	templateUrl: './generic-form-gen.component.html',
	styleUrls: ['./generic-form-gen.component.scss'],
	//VERIFY CHANGEDETECTION
	//changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericFormGenComponent implements OnInit, OnChanges, OnDestroy {
	icons = {
		faAngleRight: faAngleRight,
		faAngleLeft: faAngleLeft,
		faQuestionCircle: faQuestionCircle,
		faSearch: faSearch,
		faTrash: faTrash,
		faSquarePen: faSquarePen,
		faInfoCircle: faInfoCircle,
		faTimes: faTimes,
		faGripVertical: faGripVertical,
	};

	@Input()
	labels: LabelsInterface = {
		lbl_geral_selecione: 'SELECT',
		lbl_geral_nao: 'No',
		lbl_geral_sim: 'Yes',
		lbl_geral_disponiveis: 'Available',
		lbl_geral_selecionados: 'Selected',
		lbl_geral_adicionar: 'Add',
		lbl_geral_de: 'From',
		lbl_geral_para: 'To',
		lbl_bulletin_actions: '',
		lbl_clique_confirmar_acao: '',
		lbl_edocs_carregando: '',
		lbl_novos_itens_disponibilizados: '',
		lbl_indicadores_salvos: '',
		lbl_geral_pesquisar: '',
		lbl_geral_limpar_campos: '',
		lbl_cmdb_period: '',
		lbl_primeiro_dia_do_mes: '',
		lbl_geral_hoje: '',
		lbl_ultimos_30_dias: '',
		lbl_ultimos_7_dias: '',
		lbl_geral_anexar_arquivo: '',
		lbl_remover_anexo: '',
		lbl_formato_invalido_ou_corrompido: '',
		lbl_tipos_arquivo_permitidos: '',
		lbl_limite_tamanho_excedido: '',
		lbl_geral_cancelar: '',
		lbl_atualizar_item: '',
		lbl_rep_custom_arquivo_nao_encontrado: '',
		lbl_preencha_todos_os_campos_com_asterisco_para_incluir_field: '',
		lbl_geral_nomes_arquivos_caracteres_especiais: '',
		lbl_novo_campo_disponibilizado: '',
	};

	monthNumberToLabel = {
		'1': 'lbl_geral_janeiro',
		'2': 'lbl_geral_fevereiro',
		'3': 'lbl_geral_marco',
		'4': 'lbl_geral_abril',
		'5': 'lbl_geral_maio',
		'6': 'lbl_geral_junho',
		'7': 'lbl_geral_julho',
		'8': 'lbl_geral_agosto',
		'9': 'lbl_geral_setembro',
		'10': 'lbl_geral_outubro',
		'11': 'lbl_geral_novembro',
		'12': 'lbl_geral_dezembro',
	};

	weekdayNumberToLabel = {
		'0': 'lbl_geral_domingo',
		'1': 'lbl_geral_segunda',
		'2': 'lbl_geral_terca',
		'3': 'lbl_geral_quarta',
		'4': 'lbl_geral_quinta',
		'5': 'lbl_geral_sexta',
		'6': 'lbl_geral_sabado',
	};

	constructor(
		private LabelsService: LabelsService,
		private NotificationService: NotificationService,
		private GenericFormGenService: GenericFormGenService,
		private FilesService: FilesService,
		private ngZone: NgZone
	) {}

	isLoadingLabels = true;
	isLoadingAllowedMimeType = true;

	//Caso você tenha formulários separados mas precisa fazer
	//fazer a comunicação entre eles (por exemplo no auto write)
	//Adicionar ambos formulários em uma interface e jogar na variável de bus.
	@Input()
	setCommunicationBusForm: genericFormI[] = [];

	@Input()
	setGenericForm: genericFormI[] = [];

	@Output()
	getGenericForm = new EventEmitter();

	@Input() isLoading = false;
	@Input() loadingType: 'dot' | 'bar' = 'dot';

	@Output()
	finishLoading = new EventEmitter();

	//just an validator if you typed something
	@Output()
	valueTap = new EventEmitter();
	@Output()
	tappedField = new EventEmitter();

	@Input()
	triggerRequired = false;
	@Output()
	areRequiredFulfilled = new EventEmitter();

	@Input()
	idToHide: string[] = [];

	allowedMimeTypes: mimeTypeInterface[] = [];
	allowedMimeTypeStr = '';
	allowedMimeTypeTip = '';

	//Config
	@Input()
	columns = 1;
	_columns = 1;
	@Input()
	boldLabel = true;
	@Input()
	hideTitle = false;
	@Input()
	disabled = false;
	@Input()
	periodDatePeriodOnly = true;
	@Input()
	customerCurrency = '';
	@Input()
	postFormat = false;

	ngOnInit(): void {
		forkJoin([this.LabelsService.getLabels(), this.FilesService.getAllowedMimeType()]).subscribe((forkRes) => {
			const labels = forkRes[0];
			const allowedMimeTypes = forkRes[1];

			this.labels = labels;
			this.isLoadingLabels = false;

			this.allowedMimeTypes = allowedMimeTypes;
			this.allowedMimeTypeTip += `${this.labels.lbl_tipos_arquivo_permitidos}: `;
			for (const [index, mt] of this.allowedMimeTypes.entries()) {
				this.allowedMimeTypeStr += `${mt.mime_type},`;
				this.allowedMimeTypeTip += `${mt.extension}${index == this.allowedMimeTypes.length - 1 ? '' : ', '}`;
			}
			this.allowedMimeTypeTip += ` ${Math.floor(this.allowedMimeTypes[0].max_file_size)}MB.`;
			this.isLoadingAllowedMimeType = false;

			this.finishLoading.emit(true);
		});

		if (this.columns <= 0) {
			this.columns = 1;
		}
		this._columns = window.innerWidth < 767 ? 1 : this.columns;

		window.addEventListener('resize', () => {
			this._columns = window.innerWidth < 767 ? 1 : this.columns;
		});

		if (!this.setCommunicationBusForm || (this.setCommunicationBusForm && this.setCommunicationBusForm.length === 0)) {
			this.setCommunicationBusForm = [...this.setGenericForm];
		}
		this.setAutoWrite();
		this.cleanInvalidValues();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes && changes.setGenericForm) {
			for (const field of this.setGenericForm) {
				if (field.rawInputType == undefined || field.rawInputType == '') {
					field.rawInputType = field.inputType;
				}
				// if(field.subSelect.length > 0) this.handleSubSelect(field.subSelect, field.rawValues[0]);
				if (field.inputType == 'multi-input') {
					this.filterMultiInputValues(field);
				}
				if (field.inputType == 'boolean') {
					if (field.values[0]?.toString().toLowerCase() == '1' || field.values[0]?.toString().toLowerCase() == 'true') {
						field.values[0] = 1;
						field.rawValues[0] = 1;
					} else {
						field.values[0] = 0;
						field.rawValues[0] = 0;
					}
				}

				if ((field.inputType == 'string' || field.inputType == 'textarea') && field.values.length === 0) {
					field.values[0] = '';
					field.rawValues[0] = '';
				}

				// Inicializar tip para selects que já vêm com valor preenchido E têm hasDynamicTip configurado
				if (
					(field.inputType === 'select' ||
						field.inputType === 'select-iac' ||
						field.inputType === 'select-iac/number' ||
						field.inputType === 'select-iac/string') &&
					field.hasDynamicTip === true &&
					field.values[0] &&
					field.values[0] !== '' &&
					field.values[0] !== '-1' &&
					field.items &&
					field.items.length > 0
				) {
					const selectedItem = field.items.find((item) => item.values[0]?.toString() === field.values[0]?.toString());
					if (selectedItem) {
						// Prioriza tip, depois value/id, e por último label
						field.tip = selectedItem.tip || selectedItem.label;
					}
				}
			}
		}
		if (changes && changes.triggerRequired && changes.triggerRequired.currentValue === true) {
			this.checkRequiredFields();
			setTimeout(() => {
				this.triggerRequired = false;
			}, 1);
		}
		if (changes && changes.columns) {
			this._columns = this.columns;
		}
		if (changes && changes.disabled && !changes.disabled.firstChange) {
			for (const formItem of this.setGenericForm) {
				if (this.disabled == true) {
					// formItem.rawInputType = '' + formItem.inputType;
					// formItem.inputType = "string";
				}
				if (this.disabled == false) {
					// formItem.inputType = "" + formItem.rawInputType;
				}
			}
		}
	}

	ngOnDestroy(): void {
		window.removeEventListener('resize', () => {
			this._columns = window.innerWidth < 767 ? 1 : this.columns;
		});
	}

	emitGenericForm(): void {
		this.getGenericForm.emit(this.setGenericForm);
	}

	checkRequiredFields(): boolean {
		let areRequiredFieldsFulfilled = true;
		for (const formItem of this.setGenericForm) {
			if (
				formItem.required === true &&
				!this.hideBackendControlForm().includes(formItem.name) &&
				(!formItem.values[0] ||
					formItem.values[0] == '' ||
					((formItem.inputType === 'boolean' || formItem.inputType === 'select') &&
						(formItem.values[0] === -1 || formItem.values[0] === '-1')) ||
					(formItem.inputType === 'multi-input' && /*formItem.values[0] != []*/ formItem.values.length === 0))
			) {
				areRequiredFieldsFulfilled = false;
				formItem.alert = true;
			}
		}

		this.areRequiredFulfilled.emit(areRequiredFieldsFulfilled);
		return areRequiredFieldsFulfilled;
	}

	hideBackendControlForm(): string[] {
		if (this.idToHide && this.idToHide.length === 0) return [];

		for (const fieldName of this.idToHide) {
			const findField = this.setGenericForm.find((formItem) => {
				return formItem.name == fieldName;
			});
			if (findField != undefined) findField.hidden = true;
		}

		return this.idToHide;
	}

	multiSelectItemKeyboardHandler(formItem: genericFormI, e: KeyboardEvent): void {
		const keys = ['ArrowDown', 'ArrowUp', 'Enter'];

		if (!keys.includes(e.key) || !formItem.items || formItem.items.length === 0) return;

		e.preventDefault();

		if (e.key === 'ArrowDown' && formItem.focusItemIndex != undefined && formItem.focusItemIndex != formItem.items.length - 1) {
			formItem.focusItemIndex++;
			while (formItem.rawValues.includes(formItem.items[formItem.focusItemIndex].values[0])) {
				if (formItem.focusItemIndex == formItem.items.length - 1) formItem.focusItemIndex--;
				else formItem.focusItemIndex++;
			}
		}
		if (e.key === 'ArrowUp' && formItem.focusItemIndex != undefined && formItem.focusItemIndex != 0) {
			formItem.focusItemIndex--;
			while (formItem.rawValues.includes(formItem.items[formItem.focusItemIndex].values[0])) {
				if (formItem.focusItemIndex == 0) formItem.focusItemIndex++;
				else formItem.focusItemIndex--;
			}
		}

		if (e.key === 'Enter' && formItem.focusItemIndex != undefined) {
			this.addMultiSelectValue(formItem, formItem.focusItemIndex);
			if (formItem.focusItemIndex == formItem.items.length - 1) {
				while (formItem.rawValues.includes(formItem.items[formItem.focusItemIndex].values[0])) formItem.focusItemIndex--;
			} else {
				while (formItem.rawValues.includes(formItem.items[formItem.focusItemIndex].values[0])) formItem.focusItemIndex++;
			}
		}

		if (formItem.focusItemIndex == undefined) formItem.focusItemIndex = 0;
		document.querySelectorAll('.multiSelectFocus')[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
	}

	multiSelectValueKeyboardHandler(formItem: genericFormI, e: KeyboardEvent): void {
		const keys = ['ArrowDown', 'ArrowUp', 'Enter'];

		if (!keys.includes(e.key) || !formItem.values || formItem.values.length === 0) return;

		e.preventDefault();

		if (e.key === 'ArrowDown' && formItem.focusValueIndex != undefined && formItem.focusValueIndex != formItem.values.length - 1) {
			if (formItem.focusValueIndex >= formItem.values.length - 1) formItem.focusValueIndex = formItem.values.length - 1;
			else formItem.focusValueIndex++;
		}
		if (e.key === 'ArrowUp' && formItem.focusValueIndex != undefined && formItem.focusValueIndex != 0) {
			if (formItem.focusValueIndex <= 0) formItem.focusValueIndex = 0;
			else formItem.focusValueIndex--;
		}

		if (e.key === 'Enter' && formItem.focusValueIndex != undefined) {
			this.removeMultiSelectValue(formItem, formItem.focusValueIndex);
			if (formItem.focusValueIndex >= formItem.values.length - 1) formItem.focusValueIndex = formItem.values.length - 1;
			else formItem.focusValueIndex++;
		}

		if (formItem.focusValueIndex == undefined) formItem.focusValueIndex = 0;
		document.querySelectorAll('.multiSelectFocus')[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
	}

	multiSelectStartHold(formItem: genericFormI<'multi-select'>, itemIndex: number): void {
		formItem.isHeld = true;
		formItem.heldFirstIndex = itemIndex;
		formItem.heldLastIndex = itemIndex;
		if (formItem.focusSide == 'item') formItem.focusItemIndex = itemIndex;
		else formItem.focusValueIndex = itemIndex;
	}

	multiSelectEndHold(formItem: genericFormI<'multi-select'>) {
		const firstHeldIndex = formItem.heldFirstIndex < formItem.heldLastIndex ? formItem.heldFirstIndex : formItem.heldLastIndex;
		const lastHeldIndex = formItem.heldFirstIndex > formItem.heldLastIndex ? formItem.heldFirstIndex : formItem.heldLastIndex;

		if (formItem.focusSide == 'item') {
			for (let index = firstHeldIndex; index <= lastHeldIndex; index++) {
				if (!formItem.rawValues.includes(formItem.items[index].values[0])) this.addMultiSelectValue(formItem, index);
			}
		} else {
			for (let index = lastHeldIndex; index >= firstHeldIndex; index--) {
				this.removeMultiSelectValue(formItem, index);
			}
		}
		this.multiSelectClearHold(formItem);
	}

	multiSelectClearHold(formItem: genericFormI<'multi-select'>): void {
		formItem.isHeld = false;
		formItem.heldFirstIndex = null;
		formItem.heldLastIndex = null;
		formItem.focusItemIndex = null;
		formItem.focusValueIndex = null;
	}

	multiSelectMoveHold(formItem: genericFormI<'multi-select'>, itemIndex: number) {
		formItem.heldLastIndex = itemIndex;
	}

	addMultiSelectValue(formItem: genericFormI, itemIndex: number): void {
		const formItemItem = formItem.items[itemIndex];
		if (formItemItem?.unchangeable == true || formItemItem?.disabled == true || this.disabled == true) return;

		formItem.alert = false;
		// Verificar se formItem.values está definido e inicializá-lo como um array vazio, se necessário
		if (!formItem.values) {
			formItem.values = [];
		}
		formItem.values.push(formItemItem);
		formItem.stringifiedValue = formItem.rawValues.join(', ');
		// Verificar e inicializar formItem.rawValues, se necessário
		if (!formItem.rawValues) {
			formItem.rawValues = [];
		}
		formItem.rawValues.push(formItemItem.values[0]);
		formItem.extraFunction ? formItem.extraFunction(formItemItem) : null;

		this.valueTapField(formItem);
	}

	addMultiInputMultiSelectValue(formItemIndex: number, multiInputIndex: number, itemIndex: number): void {
		const formItem = this.setGenericForm[formItemIndex].items[multiInputIndex];
		const formItemItem = formItem.items[itemIndex];

		if (formItemItem?.unchangeable == true || formItemItem?.disabled == true || this.disabled == true) return;
		formItem.alert = false;
		// Verificar se formItem.values está definido e inicializá-lo como um array vazio, se necessário
		if (!formItem.values) {
			formItem.values = [];
		}
		formItem.values.push(formItemItem);

		// Verificar e inicializar formItem.rawValues, se necessário
		if (!formItem.rawValues) {
			formItem.rawValues = [];
		}
		formItem.rawValues.push(formItemItem.values[0]);
		formItem.extraFunction ? formItem.extraFunction(formItemItem) : null;
	}

	removeMultiSelectValue(formItem: genericFormI, valueIndex: number): void {
		const formItemItem = formItem.values[valueIndex];

		if (formItemItem?.unchangeable == true || formItemItem?.disabled == true || this.disabled == true) return;

		formItem.values.splice(valueIndex, 1);
		formItem.rawValues.splice(valueIndex, 1);
		formItem.stringifiedValue = formItem.rawValues.join(', ');

		this.valueTapField(formItem);
	}

	removeMultiInputMultiSelectValue(formItemIndex: number, multiInputIndex: number, valueIndex: number): void {
		const formItem = this.setGenericForm[formItemIndex].items[multiInputIndex];
		const formItemItem = formItem.values[valueIndex];

		if (formItemItem?.unchangeable == true || formItemItem?.disabled == true || this.disabled == true) return;

		formItem.values.splice(valueIndex, 1);
		formItem.rawValues.splice(valueIndex, 1);
		this.valueTap.emit(true);
	}

	pushAllMultiSelectValues(field: genericFormI | string): void {
		const targetField =
			typeof field === 'string'
				? this.setGenericForm.find((formItem) => {
						return formItem.name == field;
					})
				: field;

		if (targetField == undefined) return;

		if (targetField?.unchangeable == true || targetField.disabled || this.disabled == true) return;

		for (let index = 0; index < targetField.items.length; index++) {
			const item = <genericFormI>targetField.items[index];
			if (item?.unchangeable == true) continue;
			if (targetField.values.includes(item)) continue;
			targetField.values.push(item);
			targetField.rawValues.push(item.values[0]);
		}
		targetField.stringifiedValue = targetField.rawValues.join(', ');

		this.valueTapField(targetField);
	}

	pushAllMultiInputMultiSelectValues(field: genericFormI, multiInputIndex: number): void {
		const fieldItem = field.items[multiInputIndex];

		if (fieldItem?.unchangeable == true || fieldItem?.disabled || this.disabled == true) return;

		for (let index = 0; index < fieldItem.items.length; index++) {
			const item = <genericFormI>fieldItem.items[index];
			if (item?.unchangeable == true) continue;
			if (fieldItem.values.includes(item)) continue;
			fieldItem.values.push(item);
			fieldItem.rawValues.push(item.values[0]);
		}

		this.valueTap.emit(true);
	}

	pullAllMultiSelectValues(field: genericFormI): void {
		if (field?.unchangeable == true || field.disabled || this.disabled == true) return;

		for (let index = 0; index < field.values.length; index++) {
			const value = <genericFormI>field.values[index];
			if (value?.unchangeable == true) continue;
			field.values.splice(index, 1);
			field.rawValues.splice(index, 1);
			index--;
		}
		field.stringifiedValue = field.rawValues.join(', ');

		this.valueTapField(field);
	}

	pullAllMultiInputMultiSelectValues(field: genericFormI, multiInputIndex: number): void {
		const item = field.items[multiInputIndex];

		if (item?.unchangeable == true || item.disabled || this.disabled == true) return;

		for (let index = 0; index < item.values.length; index++) {
			const value = <genericFormI>item.values[index];
			if (value?.unchangeable == true) continue;
			item.values.splice(index, 1);
			item.rawValues.splice(index, 1);
			index--;
		}
	}

	setDragPosition(formItemDOM: HTMLElement, formItem: genericFormI<'multi-select'>, me: MouseEvent): void {
		const rect = formItemDOM.getBoundingClientRect();
		formItem.dragPosition.x = me.clientX - rect.left + 4;
		formItem.dragPosition.y = me.clientY - rect.top + 4;
	}

	moveDragItem(formItem: genericFormI, from: 'items' | 'values', to: 'items' | 'values', toIndex: number) {
		const fromIndex = formItem[from].indexOf(formItem.draggingItem);
		// let fromItem = formItem[from][fromIndex];
		const toItem = formItem[to][toIndex];
		if ((from == 'values' && to == 'items') || formItem.isDraggingItem == false || formItem.draggingItem.values[0] == toItem.values[0])
			return;

		if (from == 'values') formItem['rawValues'].splice(fromIndex, 1);
		formItem[from].splice(fromIndex, 1);

		if (to == 'values') formItem['rawValues'].splice(toIndex, 0, formItem.draggingItem.values[0]);
		formItem[to].splice(toIndex, 0, formItem.draggingItem);
	}

	addMultiInputValue(formItemIndex: number): void {
		const formItem = this.setGenericForm[formItemIndex];

		if (!formItem.items || !Array.isArray(formItem.items)) {
			console.error('formItem.items não inicializado ou inválido.', formItem.items);
			return;
		}

		// Validação de caracteres proibidos e campos obrigatórios
		for (let index = 0; index < formItem.items.length; index++) {
			if (formItem.items[index].values[0] && formItem.items[index].values[0].toString()?.includes('§')) {
				this.NotificationService.setNotificationMessage("_O caractere '§' é reservado e não pode ser utilizado.");
				return;
			}

			if (
				(!formItem.items[index].hidden || formItem.items[index].hidden.toString() !== '1') &&
				formItem.items[index].required === true &&
				(formItem.items[index].values[0] == undefined || formItem.items[index].values[0].toString().trim() === '')
			) {
				this.NotificationService.setNotificationMessage(
					this.labels.lbl_preencha_todos_os_campos_com_asterisco_para_incluir_field.replace(
						'{{field}}',
						this.labels[formItem.label] ? this.labels[formItem.label] : formItem.name
					)
				);
				return;
			}

			if (formItem.items[index].hidden && formItem.items[index].values[0] === '') {
				formItem.items[index].values[0] = 0;
			}
		}

		// Validação beforeAdd
		if (formItem.beforeAdd && formItem.beforeAdd() === false) {
			console.warn('beforeAdd bloqueou a execução.');
			return;
		}

		let temporaryValue: any = '';
		let temporaryRawValue: any = '';
		for (const [index, item] of formItem.items.entries()) {
			if (item.inputType === 'multi-select') {
				temporaryValue += JSON.stringify(item.values);
				temporaryRawValue += item.values.map((v) => v.values[0]).join(',');
			} else {
				temporaryValue += item.values[0];
				temporaryRawValue += item.values[0];
			}

			if (index !== formItem.items.length - 1) {
				temporaryValue += '§';
				temporaryRawValue += '§';
			}
		}

		this.cleanMultiInputItems(formItem);

		temporaryValue = typeof temporaryValue === 'string' ? temporaryValue.split('§') : [];
		temporaryRawValue = typeof temporaryRawValue === 'string' ? temporaryRawValue.split('§') : [];

		if (!formItem.values) {
			formItem.values = [];
		}
		formItem.values.push(temporaryValue);

		if (!formItem.rawValues) {
			formItem.rawValues = [];
		}
		formItem.rawValues.push(temporaryRawValue);

		// Implementação para campo indisponibility da tela de plano de mudan
		if (formItem.name === 'task') {
			for (const item of formItem.items) {
				if (item.name === 'indisponibility' && item.inputType === 'boolean') {
					item.values = ['1'];
				}
			}
		}

		if (formItem.items && formItem.items.length < 7) {
			this.filterMultiInputValues(formItem);
		} else {
			formItem.filterValues = [];
			this.filterMultiInputValues(formItem);
		}

		// Atualizando alert
		if (formItem.values.length > 0 && formItem.values[0].some((value: any) => value !== '')) {
			formItem.alert = false;
		}

		if (formItem.afterAdd != undefined) {
			formItem.afterAdd();
		}

		formItem.lastEditedItem = undefined;
		formItem.alertIndex = undefined;
		formItem.editingIndex = undefined;

		this.valueTap.emit(true);
	}

	// addMultiInputValue(formItemIndex : number): void {
	//   let formItem = this.setGenericForm[formItemIndex];

	//   for(let i = 0; i < formItem.items.length; i++) {
	//     if(formItem.items[i].values[0] && formItem.items[i].values[0].toString()?.includes('§')) {
	//       this.NotificationService.setNotificationMessage('_O caractere \'§\' é reservado e não pode ser utilizado.');
	//       return
	//     }

	//     if((!formItem.items[i].hidden || formItem.items[i].hidden.toString() != '1')
	//     && (formItem.items[i] && formItem.items[i].required == true && formItem.items[i].values[0] == undefined || formItem.items[i].required == true && formItem.items[i].values[0].toString().trim() === '')) {
	//       this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_os_campos_com_asterisco_para_incluir_field.replace('{{field}}', this.labels[formItem.label] ? this.labels[formItem.label] : formItem.name));
	//       return
	//     }

	//     if(formItem.items[i].hidden && formItem.items[i].values[0] === '') {
	//       formItem.items[i].values[0] = 0;
	//     }
	//   }

	//   //beforeAdd expect an boolean return, because it may want to check and block the flow something before adding the item
	//   if(formItem.beforeAdd && formItem.beforeAdd() == false) return;
	//   let tmpValue: any = "";
	//   let tmpRawValue: any = "";
	//   formItem.items.forEach( (item, index) => {
	//     if(item.inputType == 'multi-select') {
	//       tmpValue += JSON.stringify(item.values);
	//       tmpRawValue += item.values.map(v => v.values[0]).join(',');
	//     } else {
	//       tmpValue += item.values[0];
	//       tmpRawValue += item.values[0];
	//     }

	//     if(index != formItem.items.length -1) {
	//       tmpValue += "§";
	//       tmpRawValue += "§";
	//     };
	//   })

	//   this.cleanMultiInputItems(formItem.name);

	//   tmpValue = tmpValue.split('§');
	//   tmpRawValue = tmpRawValue.split('§');

	//   let tmp = [];
	//   tmpValue.forEach(value => {
	//     try {
	//       let pJSON = JSON.parse(value);
	//       tmp.push(pJSON);
	//     } catch { tmp.push(value) }
	//   });
	//   tmpValue = tmp;

	//   formItem.values.push(tmpValue);
	//   formItem.rawValues.push(tmpRawValue);

	//   if(formItem.items && formItem.items.length < 7) this.filterMultiInputValues(formItem.name);
	//   else { formItem.filterValues = []; this.filterMultiInputValues(formItem.name); }

	//   // Verificar se o campo não está mais vazio e definir formItem.alert como false
	//   if (formItem.values.length > 0 && formItem.values[0].some((value: any) => value !== '')) {
	//     formItem.alert = false;
	//   }

	//   if(formItem.afterAdd != null) formItem.afterAdd();
	//   formItem.lastEditedItem = undefined;
	//   formItem.alertIndex = undefined;
	//   formItem.editingIndex = undefined;

	//   this.valueTap.emit(true);
	// }

	updateMultiInputValue(formItemIndex: number): void {
		const formItem = this.setGenericForm[formItemIndex];

		for (let index = 0; index < formItem.items.length; index++) {
			if (formItem.items[index].values[0] && formItem.items[index].values[0].toString()?.includes('§')) {
				this.NotificationService.setNotificationMessage("_O caractere '§' é reservado e não pode ser utilizado.");
				return;
			}

			if (
				(!formItem.items[index].hidden || formItem.items[index].hidden.toString() != '1') &&
				((formItem.items[index] && formItem.items[index].required == true && formItem.items[index].values[0] == undefined) ||
					(formItem.items[index].required == true && formItem.items[index].values[0].toString().trim() === ''))
			) {
				this.NotificationService.setNotificationMessage(
					this.labels.lbl_preencha_todos_os_campos_com_asterisco_para_incluir_field.replace(
						'{{field}}',
						this.labels[formItem.label] ? this.labels[formItem.label] : formItem.name
					)
				);
				return;
			}

			if (formItem.items[index].hidden && formItem.items[index].values[0] === '') {
				formItem.items[index].values[0] = 0;
			}
		}

		//beforeAdd expect an boolean return, because it may want to check and block the flow something before adding the item
		if (formItem.beforeAdd && formItem.beforeAdd() == false) return;

		let temporaryValue: any = '';
		for (const [index, item] of formItem.items.entries()) {
			temporaryValue += item.values[0];
			if (index != formItem.items.length - 1) {
				temporaryValue += '§';
			}
		}

		this.cleanMultiInputItems(formItem);

		temporaryValue = temporaryValue.split('§');
		formItem.values[formItem.editingIndex] = temporaryValue;

		if (formItem.items && formItem.items.length < 7) this.filterMultiInputValues(formItem);
		else {
			formItem.filterValues = [];
			this.filterMultiInputValues(formItem);
		}

		// Verificar se o campo não está mais vazio e definir formItem.alert como false
		if (formItem.values.length > 0 && formItem.values[0].some((value: any) => value !== '')) {
			formItem.alert = false;
		}

		if (formItem.afterAdd != undefined) formItem.afterAdd();

		formItem.lastEditedItem = Number.parseInt(formItem.editingIndex.toString());
		formItem.editingIndex = undefined;
		formItem.alertIndex = undefined;
	}

	removeMultiInputValue(formItemIndex: number, removeIndex: number): void {
		const field: genericFormI = this.setGenericForm[formItemIndex];

		if (field.beforeRemove != undefined) field.beforeRemove(removeIndex);

		const selectedValue = field.outItems[removeIndex];
		for (let index = 0; index < field.values.length; index++) {
			const value = field.values[index];
			if (value === selectedValue) {
				field.values.splice(index, 1);
				break;
			}
		}
		if (field.items && field.items.length < 8) this.filterMultiInputValues(field);
		field.alertIndex = undefined;
		field.editingIndex = undefined;

		this.valueTap.emit(true);
	}

	editMultiInputValue(field: genericFormI, editIndex: number): void {
		field.editingIndex = editIndex;
		const selectedValue = field.outItems[editIndex];
		for (const [index, item] of field.items.entries()) {
			item.values[0] = selectedValue[index];
		}

		this.valueTap.emit(true);
	}

	cleanMultiInputItems(field: genericFormI): void {
		for (const [index, item] of field.items.entries()) {
			if (item.inputType === 'checkbox') item.values[0] = 0;
			else if (item.inputType === 'multi-select') item.values = [];
			else item.values[0] = '';
		}
	}

	confirmButton(elementReference: HTMLElement): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}

	setAutoWrite(): void {
		for (let index = 0; index < this.setCommunicationBusForm.length; index++) {
			const formItem = this.setCommunicationBusForm[index];
			if (
				(formItem.inputType != 'select' && formItem.inputType != 'number' && formItem.inputType != 'string') ||
				!formItem.autoWriteScript ||
				!/§§([^;]+)§§/.test(formItem.autoWriteScript)
			)
				continue;
			//Encontrou um formItem que tem autoWriteScript
			const autoWriteFieldsName = this.substringBetween(formItem.autoWriteScript, '§§', '§§');
			if (autoWriteFieldsName.length <= 0) continue;
			//Validou que o autoWriteScript tem pelo menos um campo válido para o input

			formItem.autoWriteFields = {};
			formItem.disabled = true;
			formItem.autoWrite = true;

			for (const searchFormItem of this.setCommunicationBusForm) {
				if (autoWriteFieldsName.includes(searchFormItem.name)) {
					const index_ = autoWriteFieldsName.indexOf(searchFormItem.name);
					formItem.autoWriteFields[autoWriteFieldsName[index_]] = searchFormItem;
				}
			}
		}
	}

	handleAutoWriteValue(formItemIndex: number): string {
		const fieldItem = this.setGenericForm[formItemIndex];
		const autoWriteFieldsKeys = Object.keys(fieldItem.autoWriteFields);
		let string_ = fieldItem.autoWriteScript;
		for (const fieldKey of autoWriteFieldsKeys) {
			const autoWriteFieldItem: genericFormI = fieldItem.autoWriteFields[fieldKey];
			if (!autoWriteFieldItem.values[0] || autoWriteFieldItem.values[0] === '-1' || autoWriteFieldItem.values[0] === '') {
				string_ = string_.replace(`§§${fieldKey}§§`, this.labels[autoWriteFieldItem.label]);
				continue;
			}

			if (autoWriteFieldItem.inputType === 'select') {
				for (let index = 0; index < autoWriteFieldItem.items.length; index++) {
					if (autoWriteFieldItem.items[index].values[0] != autoWriteFieldItem.values[0]) continue;
					string_ = string_.replace(`§§${fieldKey}§§`, autoWriteFieldItem.items[index].name);
					break;
				}
			} else string_ = string_.replace(`§§${fieldKey}§§`, autoWriteFieldItem.values[0]);
		}

		fieldItem.values[0] = string_;
		return string_;
	}

	handleSubSelect(subSelectArray: genericFormI['subSelect'][number][], eventValue: string) {
		for (const subSelect of subSelectArray) {
			const subFieldName = subSelect.subSelectChildName;
			const qryName = subSelect.subSelectQryName;
			const when_value_is = subSelect.when_value_is;
			const make_required = subSelect.make_required;
			const parameters = [];
			const fieldDictionaryKeys = [];
			for (const formItem of this.setGenericForm) {
				fieldDictionaryKeys.push(formItem.name);
			}
			for (const parameter of subSelect.parameters) {
				let keyName = '';
				const temporaryParameter = (<any>parameter).replaceAll('%', '.*');
				const regex = new RegExp(`^${temporaryParameter}$`);
				for (const key of fieldDictionaryKeys) {
					if (regex.test(key)) keyName = key;
				}

				const findField = this.setGenericForm.find((formItem) => {
					return formItem.name == keyName;
				});

				if (findField != undefined && findField.values[0].toString().trim() != '') {
					const keyValue = findField.values[0];
					const newParameter = { key: keyName, value: keyValue };
					parameters.push(newParameter);
				}
			}

			const subField = this.setGenericForm.find((formItem) => formItem.name == subFieldName) as genericFormI;
			if (subField == undefined) continue;

			subField.items = [];
			subField.values = [];
			subField.rawValues = [];

			//If you unselect value, re-hide the subfields;
			if (
				(eventValue && (eventValue.toString() == '-1' || eventValue.toString() == '')) ||
				(when_value_is.length > 0 && !when_value_is.includes(eventValue.toString()))
			) {
				subField.hidden = subField.rawHidden == undefined ? false : subField.rawHidden;
				subField.required = subField.rawRequired == undefined ? false : subField.rawRequired;
				subField.alert = false;
				continue;
			}

			subField.isLoading = true;

			// Se estivermos processando 'qryPeripheraltypeToModel', resetar o campo associado a 'qryManufacturerToModel'
			if (
				qryName === 'qryPeripheraltypeToModel' ||
				qryName === 'qryTelephonyToManufacturer' ||
				qryName === 'qryWorkstationToManufacturer'
			) {
				const dependentFieldName = 'model'; // Ajuste para o nome real do campo dependente (ex.: 'model')
				const dependentField = this.setGenericForm.find((formItem) => {
					return formItem.name == dependentFieldName;
				});
				if (dependentField != undefined) {
					dependentField.items = [];
					dependentField.values = [];
					dependentField.rawValues = [];
					dependentField.alert = false; // Opcional: desativar alertas até nova seleção
					dependentField.hidden = false; // Opcional: manter visível, mas vazio
				}
			}

			this.GenericFormGenService.getSubSelect(qryName, eventValue, parameters)
				.subscribe((fieldItems) => {
					subField.items = fieldItems;
				})
				.add(() => {
					subField.alert = true;
					subField.hidden = false;
					subField.isLoading = false;

					if (subSelect.make_required == true) subField.required = true;
					if (subSelect.make_required == false) subField.required = false;

					let notificationMessage = `${this.labels[subField.label] ? this.labels[subField.label] : subField.label}: `;
					notificationMessage +=
						subField.items.length > 0
							? `${this.labels.lbl_novos_itens_disponibilizados}`
							: `${this.labels.lbl_novo_campo_disponibilizado}`;
					this.NotificationService.setNotificationMessage(`${notificationMessage}`);
				});
		}
	}

	formatMoneyInput(formItem: genericFormI): void {
		let inputValue = formItem.values[0];
		if (inputValue == undefined || inputValue == '' || inputValue < 0) inputValue = '0.00';
		if (!inputValue.includes('.')) inputValue += '.00';
		formItem.values[0] = inputValue;
	}

	handleCheckboxSubSelect(subSelectArray: string[], eventValue: string) {
		for (const fieldName of subSelectArray) {
			const findField = this.setGenericForm.find((formItem) => {
				return formItem.name == fieldName;
			});
			if (findField != undefined) {
				findField.hidden = eventValue.toString().toLowerCase() == 'true' || eventValue.toString() == '1' ? false : true;
			}
		}
	}

	cleanInvalidValues(): void {
		for (let index = 0; index < this.setGenericForm.length; index++) {
			const formItem = this.setGenericForm[index];
			let hasValue = false;

			if (formItem.values == undefined) formItem.values = [];
			if (formItem.rawValues == undefined) formItem.rawValues = [];
			if (
				(formItem.inputType == 'select' ||
					formItem.inputType == 'multi-select' ||
					formItem.inputType == 'radio' ||
					formItem.inputType == 'checkbox' ||
					formItem.inputType?.includes('iac')) &&
				formItem.values.length > 0
			) {
				for (let index = 0; index < formItem.items.length; index++) {
					const item = formItem.items[index];

					if (formItem.inputType == 'multi-select' || formItem.inputType == 'multi-input') {
						if (item != formItem.values[0]) continue;
					} else {
						if (item.values[0] != formItem.values[0]) continue;
					}
					hasValue = true;
					break;
				}

				if (!hasValue && formItem.inputType == 'checkbox') {
					for (const [index, item] of formItem.items.entries()) {
						formItem.values[index] = 0;
						formItem.rawValues[index] = null;
					}
				}
			}
		}
	}

	substringBetween(string_: string, leftSide: string, rightSide: string): string[] {
		const array = [];
		while (string_ != '') {
			if (!/§§([^;]+)§§/.test(string_)) break;

			const pos = string_.indexOf(leftSide) + leftSide.length;
			array.push(string_.substring(pos, string_.indexOf(rightSide, pos)));
			string_ = string_.slice(string_.indexOf(rightSide, pos) + 2);
		}

		return array;
	}

	filterMultiInputValues(selectedField: genericFormI): void {
		selectedField.outItems = selectedField.values;

		const temporaryValues = [];
		for (const [index, initialValue] of selectedField.values.entries()) {
			let value = initialValue;
			let count = 0;

			if (!Array.isArray(value)) value = value.split('§');

			for (const [jindex, valueItem] of value.entries()) {
				if (
					!selectedField.filterValues ||
					!selectedField.filterValues[jindex] ||
					selectedField.filterValues[jindex] === '' ||
					(selectedField.filterValues[jindex] &&
						valueItem.toString().toLowerCase().includes(selectedField.filterValues[jindex].toString().toLowerCase()))
				)
					count++;
			}

			if (count === selectedField.values[index].length) {
				temporaryValues.push(value);
			}
		}

		selectedField.outItems = temporaryValues;
	}

	handleFileTask(fileElement: HTMLInputElement, formItemIndex: number): void {
		const taskFile = fileElement.files[0];
		const formItem = this.setGenericForm[formItemIndex];

		if (taskFile) {
			if (!this.FilesService.nameAllowed(taskFile)) {
				return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_nomes_arquivos_caracteres_especiais);
			}

			this.FilesService.MSPFileFromFile(taskFile).then((mspFile) => {
				if (Math.floor(mspFile.size / 1_000_000) > this.allowedMimeTypes[0].max_file_size) {
					this.NotificationService.setNotificationMessage(
						`"${mspFile.name}" ${this.labels.lbl_limite_tamanho_excedido} ${Math.floor(this.allowedMimeTypes[0].max_file_size)}MB.`
					);
				} else if (mspFile.mimeType == '' || !this.allowedMimeTypeStr.includes(mspFile.mimeType)) {
					this.NotificationService.setNotificationMessage(`"${mspFile.name}" ${this.labels.lbl_formato_invalido_ou_corrompido}`);
				} else {
					formItem.values[0] = mspFile;
					formItem.alert = false;
					formItem.extraFunction ? formItem.extraFunction(formItem.values) : null;
					this.valueTap.emit(true);
				}
			});
		} else {
			formItem.values = [];
			formItem.alert = false;
			formItem.extraFunction ? formItem.extraFunction(formItem.values) : null;
			this.valueTap.emit(true);
		}
	}

	downloadFile(filePath: string, fileSource: 'request' | 'cmdb' | 'km'): void {
		if (!filePath || !fileSource) return;

		this.GenericFormGenService.getFile(filePath, fileSource).subscribe(
			(mspFile) => {
				this.FilesService.downloadFile(this.FilesService.fileFromBase(mspFile, 'Base64'));
			},
			(error) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_rep_custom_arquivo_nao_encontrado);
			}
		);
	}

	formatMultiInputTextCallBack(value: any, formItem: genericFormI, itemIndex: number) {
		if (formItem.items[itemIndex].inputType != 'multi-select' || !value) return value;
		//If a value is an object it's expected to be an genericFormI and have it's mandatory values
		//such as, name, label and value
		value = JSON.parse(JSON.stringify(value));
		if (!Array.isArray(value)) value = [value];
		return value
			.map((v) => {
				return this.labels[v.label] ? this.labels[v.label] : v.label;
			})
			.join(', ');
	}

	handleCheckboxValues(formItem: genericFormInterface): void {
		formItem.rawValues = [];
		formItem.stringifiedValue = '';
		for (const [index, item] of formItem.items.entries()) {
			if (formItem.values[index] == 1) {
				formItem.rawValues[index] = item.values[0];
				formItem.stringifiedValue += `${item.values[0]}, `;
			} else formItem.rawValues[index] = undefined;
		}
		formItem.stringifiedValue = formItem.stringifiedValue.slice(0, Math.max(0, formItem.stringifiedValue.length - 2));
	}

	onDateChange(event: any, formInput: any): void {
		if (!event) {
			formInput.values[0] = null; // Se não houver valor, mantém null
			return;
		}

		const parsedDate = new Date(event);

		if (isNaN(parsedDate.getTime())) {
			formInput.values[0] = null; // Se a data for inválida, evita erro
			return;
		}

		// Formata corretamente para 'yyyy-MM-dd'
		formInput.values[0] = parsedDate.toISOString().split('T')[0];
	}

	setValuesFromRawValues(formItem: genericFormI): void {
		if (!formItem.rawValues || formItem.rawValues.length === 0) return;

		let selectedItem: genericFormI<'item'>;
		if (formItem.inputType == 'select' || formItem.inputType == 'select-iac') {
			//This will be used when we update selects to hold the item on its value;
			// selectedItem = formItem.items.find(item => { return item.values[0].toString() == formItem.rawValues[0].toString() });
			// if(selectedItem) {
			//   formItem.values[0] = selectedItem;
			// }
			formItem.rawValues[0] = formItem.values[0];
			return;
		}

		if (formItem.inputType == 'cronjob') {
			const cronjobValue = formItem.rawValues[0].split(' ');
			if (cronjobValue.length == 5) {
				formItem.values = cronjobValue;
			} else {
				throw 'Invalid cronjob rawValue, expected 5 values separated by space';
			}
			return;
		}

		formItem.values = formItem.rawValues;
	}

	valueTapField(field: genericFormI): void {
		this.valueTap.emit(true);
		this.tappedField.emit(field);
	}

	formatCronjobText(cronjobValue: string[]): string {
		let returnText = '';
		const sortAlphaNumber = (a, b) => a.localeCompare(b, 'en', { numeric: true });
		const minute = cronjobValue[0]
			.split(',')
			.map((minute) => {
				return this.trimLeftZeros(minute);
			})
			.filter(Boolean)
			.sort(sortAlphaNumber);
		const hour = cronjobValue[1]
			.split(',')
			.map((hour) => {
				return this.trimLeftZeros(hour);
			})
			.filter(Boolean)
			.sort(sortAlphaNumber);
		const day = cronjobValue[2]
			.split(',')
			.map((day) => {
				return this.trimLeftZeros(day);
			})
			.filter(Boolean)
			.sort(sortAlphaNumber);
		const month = cronjobValue[3]
			.split(',')
			.map((month) => {
				return this.trimLeftZeros(month);
			})
			.sort(sortAlphaNumber)
			.map((month) => {
				return this.labels[this.monthNumberToLabel[month]]
					? this.labels[this.monthNumberToLabel[month]]
					: this.monthNumberToLabel[month];
			})
			.filter(Boolean);
		const dayOfWeek = cronjobValue[4]
			.split(',')
			.map((dayOfWeek) => {
				return this.trimLeftZeros(dayOfWeek);
			})
			.sort(sortAlphaNumber)
			.map((dayOfWeek) => {
				return this.labels[this.weekdayNumberToLabel[dayOfWeek]]
					? this.labels[this.weekdayNumberToLabel[dayOfWeek]]
					: this.weekdayNumberToLabel[dayOfWeek];
			})
			.filter(Boolean);

		//Minutos e horas interagem entre si, então eles se validam; mas não colidem com os dias.
		if (minute.length == 1 && hour.length == 1 && minute[0] != '*' && minute[0] != '' && hour[0] != '*' && hour[0] != '') {
			Number.parseInt(minute[0]) < 10 ? (minute[0] = '0' + minute[0]) : null;
			Number.parseInt(hour[0]) < 10 ? (hour[0] = '0' + hour[0]) : null;
			returnText += `${this.labels['lbl_geral_as'].charAt(0).toUpperCase() + this.labels['lbl_geral_as'].slice(1)} ${hour}:${minute} `;
		} else {
			if (minute.length === 0 || (hour.length == 1 && (hour[0] == '*' || hour[0] == '')))
				returnText += `${this.labels['lbl_todo_minuto']} `;
			else if (minute.length == 1) returnText += `${this.labels['lbl_no_minuto'].replace('§_minute_§', minute.toString())} `;
			else if (minute.length > 1)
				returnText += `${this.labels['lbl_nos_minutos'].replace('§_minute_§', minute.join(', ')).replace(new RegExp(/(,)(?!.*\1)/), ' ' + this.labels['lbl_geral_e'] + ' ')} `;

			if (hour.length == 1 && hour[0] != '*' && hour[0] != '')
				returnText += `${this.labels['lbl_apos_a_hora'].replace('§_hour_§', hour.toString()).toLowerCase()} `;
			else if (hour.length > 1)
				returnText += `${this.labels['lbl_apos_as_horas']
					.replace('§_hour_§', hour.join(', '))
					.replace(new RegExp(/(,)(?!.*\1)/), ' ' + this.labels['lbl_geral_e'] + ' ')
					.toLowerCase()} `;
		}

		if (day.length == 1 && day[0] != '*' && day[0] != '') {
			returnText += `${this.labels['lbl_no_dia'].replace('§_day_§', day.toString()).toLowerCase()} `;
		} else if (day.length > 1)
			returnText += `${this.labels['lbl_nos_dias']
				.replace('§_day_§', day.join(', '))
				.replace(new RegExp(/(,)(?!.*\1)/), ' ' + this.labels['lbl_geral_e'] + ' ')
				.toLowerCase()} `;

		if (dayOfWeek.length > 0 && dayOfWeek[0] != '*' && dayOfWeek[0] != '') {
			returnText += `${this.labels['lbl_no_weekday']
				.replace('§_weekday_§', dayOfWeek.join(', '))
				.replace(new RegExp(/(,)(?!.*\1)/), ' ' + this.labels['lbl_geral_e'] + ' ')
				.toLowerCase()} `;
		}

		if (month.length > 0 && month[0] != '*' && month[0] != '') {
			returnText += `${this.labels['lbl_em_month']
				.replace('§_month_§', month.join(', '))
				.replace(new RegExp(/(,)(?!.*\1)/), ' ' + this.labels['lbl_geral_e'] + ' ')
				.toLowerCase()} `;
		}

		returnText = `${returnText.trim()}.`;
		return returnText;
	}

	formatCronjobMinute(formItem: genericFormI, minuteInputElement: HTMLInputElement, minuteString: string): void {
		const regExp = /^(\*|([0-5]?\d))(,(\*|([0-5]?\d)))*$/;
		formItem.values[0] = minuteString;
		formItem.rawValues[0] = formItem.values.join(' ');
		minuteInputElement.value = minuteString;
		if (regExp.test(minuteString)) {
			minuteInputElement.classList.remove('required-alert');
		} else {
			minuteInputElement.classList.add('required-alert');
		}
	}

	formatCronjobHour(formItem: genericFormI, hourInputElement: HTMLInputElement, hourString: string): void {
		const regExp = /^(\*|([01]?\d|2[0-3]))(,(\*|([01]?\d|2[0-3])))*$/;
		formItem.values[1] = hourString;
		formItem.rawValues[0] = formItem.values.join(' ');
		hourInputElement.value = hourString;
		if (regExp.test(hourString)) {
			hourInputElement.classList.remove('required-alert');
		} else {
			hourInputElement.classList.add('required-alert');
		}
	}

	formatCronjobDay(formItem: genericFormI, dayInputElement: HTMLInputElement, dayString: string): void {
		const regExp = /^(\*|([12]?\d|3[01]))(,(\*|([12]?\d|3[01])))*$/;
		formItem.values[2] = dayString;
		formItem.rawValues[0] = formItem.values.join(' ');
		dayInputElement.value = dayString;
		if (regExp.test(dayString)) {
			dayInputElement.classList.remove('required-alert');
		} else {
			dayInputElement.classList.add('required-alert');
		}
	}

	formatCronjobMonth(formItem: genericFormI, monthInputElement: HTMLInputElement, monthString: string): void {
		const regExp = /^(\*|([1-9]|1[0-2]))(,(\*|([1-9]|1[0-2])))*$/;
		formItem.values[3] = monthString;
		formItem.rawValues[0] = formItem.values.join(' ');
		monthInputElement.value = monthString;
		if (regExp.test(monthString)) {
			monthInputElement.classList.remove('required-alert');
		} else {
			monthInputElement.classList.add('required-alert');
		}
	}

	formatCronjobDayOfWeek(formItem: genericFormI, dayOfWeekInputElement: HTMLInputElement, dayOfWeekString: string): void {
		const regExp = /^(\*|[0-6])(,(\*|[0-6]))*$/;
		formItem.values[4] = dayOfWeekString;
		formItem.rawValues[0] = formItem.values.join(' ');
		dayOfWeekInputElement.value = dayOfWeekString;
		if (regExp.test(dayOfWeekString)) {
			dayOfWeekInputElement.classList.remove('required-alert');
		} else {
			dayOfWeekInputElement.classList.add('required-alert');
		}
	}

	trimLeftZeros(number: string | number): string {
		let returnValue = Number.parseInt(<string>number).toString();
		if (returnValue == 'NaN') returnValue = '';
		return returnValue;
	}

	cronjobMonth(monthString: string): string {
		return monthString
			.split(',')
			.map((month) => {
				if (this.labels[this.monthNumberToLabel[month]]) return this.labels[this.monthNumberToLabel[month]];
				return this.monthNumberToLabel[month];
			})
			.join(', ');
	}

	cronjobWeekDay(weekdayString: string): string {
		return weekdayString
			.split(',')
			.map((weekday) => {
				if (this.labels[this.weekdayNumberToLabel[weekday]]) return this.labels[this.weekdayNumberToLabel[weekday]];
				return this.weekdayNumberToLabel[weekday];
			})
			.join(', ');
	}

	updateSelectTip(formItem: genericFormI, selectedValue: any): void {
		console.log('selectedValue', selectedValue);
		if (!formItem.items || formItem.items.length === 0) return;

		const selectedItem = formItem.items.find((item) => item.values[0]?.toString() === selectedValue?.toString());

		if (selectedItem) {
			// Atualiza o tip com o label do item selecionado
			formItem.tip = selectedItem.label || selectedItem.name;
		} else {
			// Se não encontrar, limpa o tip
			formItem.tip = '';
		}
	}

	//Public functions
	public cleanValues(): void {
		for (const formItem of this.setGenericForm) {
			if (formItem.items?.length > 0) {
				formItem.values = [];
				formItem.rawValues = [];
			} else {
				formItem.values = [''];
				formItem.rawValues = [''];
			}
			formItem.alert = false;
			formItem.editingIndex = undefined;
			formItem.alertIndex = undefined;
		}
	}

	public cleanValuesByFieldName(fieldName: string): void {
		const formItem = this.setGenericForm.find((item) => item.name == fieldName);
		if (formItem) {
			if (formItem.items?.length > 0) {
				formItem.values = [];
				formItem.rawValues = [];
			} else {
				formItem.values = [''];
				formItem.rawValues = [''];
			}

			formItem.alert = false;
			formItem.editingIndex = undefined;
			formItem.alertIndex = undefined;
		}
	}
}
